import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ButtonTryAgain from '../components/buttons/ButtonTryAgain';
import Icon from '../components/icons/Icon';
import Summary from "../form/Summary";
import { TransactionSearchOperation } from "../../types";

type Props = {
  transactionSearchResult: TransactionSearchOperation;
};
const NoResultView = ({ transactionSearchResult }: Props) => {
  const intl = useIntl();

  return (
    <main>
      <Summary transactionSearchResult={transactionSearchResult}/>
      <div className="column column-2">
        <article className="search-form">
          <header className="row">
            <h1>
              <FormattedMessage id="status.notFound.title" />
            </h1>
          </header>
          <div className="main">
            <div className="status no-result">
              <div className="status not-found">
                <Icon type="INFO" />
              </div>
              <div className="content not-found">
                  <FormattedMessage
                    id="status.notFound.message"
                    values={{
                      a: (chunks) => (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={intl.formatMessage({ id: 'payu.contact.url' })}
                        >
                          {chunks}
                        </a>
                      ),
                    }}
                  />
              </div>
            </div>
            <ButtonTryAgain className={"tryAgain"}/>
          </div>
        </article>
      </div>
      </main>
  );
};

export default NoResultView;
